import {
  FETCH_CSV_IMPORT_LOGS_REQUEST,
  FETCH_CSV_IMPORT_LOGS_SUCCESS,
  FETCH_CSV_IMPORT_LOGS_FAILURE,
  FETCH_ACTIVE_CSV_IMPORT_LOGS_REQUEST,
  FETCH_ACTIVE_CSV_IMPORT_LOGS_SUCCESS,
  FETCH_ACTIVE_CSV_IMPORT_LOGS_FAILURE,
  FETCH_CSV_IMPORT_LOG_BY_ID_REQUEST,
  FETCH_CSV_IMPORT_LOG_BY_ID_SUCCESS,
  FETCH_CSV_IMPORT_LOG_BY_ID_FAILURE,
  FETCH_CSV_IMPORT_LOG_BY_REFERENCE_REQUEST,
  FETCH_CSV_IMPORT_LOG_BY_REFERENCE_SUCCESS,
  FETCH_CSV_IMPORT_LOG_BY_REFERENCE_FAILURE,
  CREATE_CSV_IMPORT_LOG_REQUEST,
  CREATE_CSV_IMPORT_LOG_SUCCESS,
  CREATE_CSV_IMPORT_LOG_FAILURE,
  UPDATE_CSV_IMPORT_LOG_REQUEST,
  UPDATE_CSV_IMPORT_LOG_SUCCESS,
  UPDATE_CSV_IMPORT_LOG_FAILURE,
  UPDATE_CSV_IMPORT_LOG_CONFIRMATION_REQUEST,
  UPDATE_CSV_IMPORT_LOG_CONFIRMATION_SUCCESS,
  UPDATE_CSV_IMPORT_LOG_CONFIRMATION_FAILURE,
  DELETE_CSV_IMPORT_LOG_REQUEST,
  DELETE_CSV_IMPORT_LOG_SUCCESS,
  DELETE_CSV_IMPORT_LOG_FAILURE,
  FETCH_CSV_IMPORT_LOGS_STATS_REQUEST,
  FETCH_CSV_IMPORT_LOGS_STATS_SUCCESS,
  FETCH_CSV_IMPORT_LOGS_STATS_FAILURE,
  FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_REQUEST,
  FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_SUCCESS,
  FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_FAILURE
} from '../../types/csvImportLogs/csvImportLogsTypes';

import {
  fetchAllCsvImportLogs,
  fetchActiveCsvImportLogs,
  fetchCsvImportLogById,
  fetchCsvImportLogByReference,
  createCsvImportLog,
  updateCsvImportLog,
  updateCsvImportLogConfirmation,
  softDeleteCsvImportLog,
  hardDeleteCsvImportLog,
  fetchCsvImportLogsByDateRange,
  fetchCsvImportLogsStats,
} from '../../../api/csvImportLogs/csvImportLogsApi';

// Fetch all CSV import logs
export const fetchAllCsvImportLogsAction = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CSV_IMPORT_LOGS_REQUEST });
    const response = await fetchAllCsvImportLogs();
    dispatch({
      type: FETCH_CSV_IMPORT_LOGS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_CSV_IMPORT_LOGS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch CSV import logs'
    });
    throw error;
  }
};

// Fetch active CSV import logs
export const fetchActiveCsvImportLogsAction = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ACTIVE_CSV_IMPORT_LOGS_REQUEST });
    const response = await fetchActiveCsvImportLogs();
    dispatch({
      type: FETCH_ACTIVE_CSV_IMPORT_LOGS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_ACTIVE_CSV_IMPORT_LOGS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch active CSV import logs'
    });
    throw error;
  }
};

// Fetch CSV import log by ID
export const fetchCsvImportLogByIdAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CSV_IMPORT_LOG_BY_ID_REQUEST });
    const response = await fetchCsvImportLogById(id);
    dispatch({
      type: FETCH_CSV_IMPORT_LOG_BY_ID_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_CSV_IMPORT_LOG_BY_ID_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch CSV import log'
    });
    throw error;
  }
};

// Fetch CSV import log by reference number
export const fetchCsvImportLogByReferenceAction = (referenceNumber) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CSV_IMPORT_LOG_BY_REFERENCE_REQUEST });
    const response = await fetchCsvImportLogByReference(referenceNumber);
    dispatch({
      type: FETCH_CSV_IMPORT_LOG_BY_REFERENCE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_CSV_IMPORT_LOG_BY_REFERENCE_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch CSV import log'
    });
    throw error;
  }
};

// Create CSV import log
export const createCsvImportLogAction = (logData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CSV_IMPORT_LOG_REQUEST });
    const response = await createCsvImportLog(logData);
    dispatch({
      type: CREATE_CSV_IMPORT_LOG_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create CSV import log';
    dispatch({
      type: CREATE_CSV_IMPORT_LOG_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

// Update CSV import log
export const updateCsvImportLogAction = (id, logData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CSV_IMPORT_LOG_REQUEST });
    const response = await updateCsvImportLog(id, logData);
    dispatch({
      type: UPDATE_CSV_IMPORT_LOG_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update CSV import log';
    dispatch({
      type: UPDATE_CSV_IMPORT_LOG_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

// Update CSV import log confirmation status
export const updateCsvImportLogConfirmationAction = (id, isConfirm) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CSV_IMPORT_LOG_CONFIRMATION_REQUEST });
    const response = await updateCsvImportLogConfirmation(id, isConfirm);
    dispatch({
      type: UPDATE_CSV_IMPORT_LOG_CONFIRMATION_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update confirmation status';
    dispatch({
      type: UPDATE_CSV_IMPORT_LOG_CONFIRMATION_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

// Soft delete CSV import log
export const softDeleteCsvImportLogAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CSV_IMPORT_LOG_REQUEST });
    const response = await softDeleteCsvImportLog(id);
    dispatch({
      type: DELETE_CSV_IMPORT_LOG_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete CSV import log';
    dispatch({
      type: DELETE_CSV_IMPORT_LOG_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

// Hard delete CSV import log
export const hardDeleteCsvImportLogAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CSV_IMPORT_LOG_REQUEST });
    const response = await hardDeleteCsvImportLog(id);
    dispatch({
      type: DELETE_CSV_IMPORT_LOG_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete CSV import log';
    dispatch({
      type: DELETE_CSV_IMPORT_LOG_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

// Fetch CSV import logs statistics
export const fetchCsvImportLogsStatsAction = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CSV_IMPORT_LOGS_STATS_REQUEST });
    const response = await fetchCsvImportLogsStats();
    dispatch({
      type: FETCH_CSV_IMPORT_LOGS_STATS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_CSV_IMPORT_LOGS_STATS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch CSV import logs statistics'
    });
    throw error;
  }
};

// Fetch CSV import logs by date range
export const fetchCsvImportLogsByDateRangeAction = (startDate, endDate) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_REQUEST });
    const response = await fetchCsvImportLogsByDateRange(startDate, endDate);
    dispatch({
      type: FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch CSV import logs by date range'
    });
    throw error;
  }
}; 